import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import GreenSpinner from "../../Shared/Loading/GreenSpinner";
import axios from "axios";
import ModalShortlistedGreen from "../ProcessingLeads/AdminShortListed/AdminShortListedGreen/ModalShortlistedGreen";

const SMSGreenTutor = () => {
  const [tutors, setTutors] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchPhone, setSearchPhone] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [loading, setLoading] = useState(true);
  /////////////////// sms entry start ////////////////////
  const [selectedPhoneNumbers, setSelectedPhoneNumbers] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  console.log("phones", selectedPhoneNumbers);

  // Function to handle individual checkbox change
  const handleCheckboxChange = (phone, isChecked) => {
    if (isChecked) {
      setSelectedPhoneNumbers([...selectedPhoneNumbers, phone]);
    } else {
      setSelectedPhoneNumbers(
        selectedPhoneNumbers.filter((number) => number !== phone)
      );
    }
  };

  // Function to handle 'Select All' checkbox change
  const handleSelectAllChange = (isChecked) => {
    setSelectAllChecked(isChecked);
    if (isChecked) {
      const allPhoneNumbers = tutors.map((item) => item.phone);
      setSelectedPhoneNumbers(allPhoneNumbers);
    } else {
      setSelectedPhoneNumbers([]);
    }
  };

  ////////////////////////// MEJOR PART SENT SMS START ///////////////////////////
  //   const [contacts, setContacts] = useState('');

  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://tutor-tree-server-1.vercel.app/sendSMS", {
        contacts: selectedPhoneNumbers.join(","), // Send the phone numbers as a single string
        message,
      });
      console.log(response.data);
      toast.success("message send successfully");
    } catch (error) {
      console.error("Error sending SMS", error);
      toast.success("Error sending SMS");
    }
  };
  ////////////////////////// MEJOR PART SENT SMS END  ///////////////////////////
  /////////////////// sms entry end   ////////////////////
  //  sms function end

  // Fetch tutors whenever the current page, searchPhone, or searchEmail changes
  useEffect(() => {
    fetchTutors(currentPage, searchPhone, searchEmail);
  }, [currentPage, searchPhone, searchEmail]);

  // Fetch tutors with pagination and search
  const fetchTutors = async (page, phone, email) => {
    try {
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/tutorAdminGreen?page=${page}&phone=${phone}&email=${email}`
      );
      const data = await response.json();
      setTutors(data.tutors);
      setTotalPages(data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching tutors:", error);
    }
  };

  // Handle page navigation and keep search query intact
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const handleMakeAdmin = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/users/admin/${id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Make admin successful.");

          // Re-fetch the updated user data
          fetchTutors(); // Call the fetchTutors function again to update the user data
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const handleMakeSuperAdmin = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/users/superAdmin/${id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Make super admin successful.");

          // Re-fetch the updated user data
          fetchTutors(); // Call the fetchTutors function again to update the user data
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  const handleRemoveRole = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/users/removeAdmin/${id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Remove role successful.");

          // Re-fetch the updated user data
          fetchTutors(); // Call the fetchTutors function again to update the user data
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };
  if (loading) return <GreenSpinner></GreenSpinner>;

  //  sms function start

  ///////////// subjects Hons

  return (
    <div className="flex flex-col justify-between bg-green-100">
      <div className="w-full h-10 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat">
          All Tutors
        </h2>
      </div>
      {/* sms */}
      <div className="w-full p-5">
      <h1 className="text-lg font-montserrat my-2 ">Phone Numbers : {selectedPhoneNumbers.length}</h1>

          <div className="flex flex-row w-[80%] overflow-y-auto">
            {selectedPhoneNumbers.map((phone) => (
              <div className="my-3 mx-2 bg-green-200 rounded px-2 py-1 text-green-900 font-montserrat">{phone}</div>
            ))}
          </div>
          <form className="flex flex-col mt-4" onSubmit={handleSubmit}>
            <label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="textarea w-[800px]  border border-green-600"
                placeholder="type message...."
              />
            </label>
            <div className="flex justify-start">
              <button
                className="bg-green-600 px-4 py-2 font-montserrat text-white mt-2 rounded-md"
                type="submit"
              >
                Send SMS
              </button>
            </div>
          </form>
        </div>

      {/* sms end */}
      <div className="bg-green-500 px-5 w-full my-4">
        <div className="py-2 w-[30%] flex justify-between  my-t">
          <input
            type="text"
            placeholder="Search by Phone"
            className="border border-green-500 rounded-lg font-montserrat"
            value={searchPhone}
            onChange={(e) => {
              setSearchPhone(e.target.value);
              setCurrentPage(1); // Reset to first page when search query changes
            }}
          />
          <input
            type="text"
            placeholder="Search by Email"
            className="border border-green-500 rounded-lg font-montserrat"
            value={searchEmail}
            onChange={(e) => {
              setSearchEmail(e.target.value);
              setCurrentPage(1); // Reset to first page when search query changes
            }}
          />
        </div>
      </div>

      <div className="w-full bg-white mt-5">
        <div class=" overflow-x-auto h-[600px]">
          <div class="relative  shadow-md sm:rounded-lg">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-white uppercase bg-green-500 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    #
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 flex flex-row gap-4 items-center justify-start"
                  >
                    <input
                      type="checkbox"
                      id="selectAll"
                      className="checked:bg-blue-600 checked:border-transparent"
                      onChange={(e) => handleSelectAllChange(e.target.checked)}
                      checked={selectAllChecked}
                    />
                    <h1 className="pr-2">Select All</h1>
                  </th>

                  <th scope="col" class="px-6 py-3">
                    Name
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Email
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Phone Number
                  </th>
                
                </tr>
              </thead>
              {tutors.map((apply, index) => (
                <tbody>
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {index + 1}
                    </th>
                    <th scope="row" class="px-6 py-4">
                      <input
                        type="checkbox"
                        className="checked:bg-blue-600 checked:border-transparent"
                        onChange={(e) =>
                          handleCheckboxChange(apply.phone, e.target.checked)
                        }
                        checked={
                          selectAllChecked ||
                          selectedPhoneNumbers?.includes(apply.phone)
                        }
                      />
                    </th>

                    <td class="px-6 py-4">{apply.name}</td>
                    <td class="px-6 py-4">{apply.email}</td>
                    <td class="px-6 py-4">{apply.phone}</td>

                  
                  </tr>
          
                </tbody>
              ))}
            </table>
            <div className="flex justify-center items-start ">
              <div className="flex justify-between my-5 w-[300px]">
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                >
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
                <span className="text-lg font-roboto">
                  Page {currentPage} of {totalPages}
                </span>
                <button onClick={handleNextPage}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default SMSGreenTutor;
